import React from "react";
import { Route as BasicRoute, Redirect, Switch } from "react-router";
import { BrowserRouter, Route } from "react-router-dom";

import WrapperFrame from "@configuratorware/configurator-frontendgui/App/Frame";
import ErrorBoundary from "@configuratorware/configurator-frontendgui/App/Error/ErrorBoundary";

import combinedScreens from "@configuratorware/configurator-frontendgui/App/Screens";

import { getConf } from "@configuratorware/configurator-frontendgui/App/configuration.js";
import LevelSelectionComponent from "./Components/LevelOverview/LevelSelectionComponent";
import { useSelector } from "react-redux";
import { get } from "lodash";

const NoMatch = () => <div>No routing found for the specified path.</div>;

const Routing = (props) => {
  const basePath = getConf("routingBasePath", "/");

  const level_visibility = useSelector((state) =>
    get(state, "configurator.configuration.customdata.level_visibility", null)
  );
  const itemIdentifier = useSelector((state) =>
    get(state, "configurator.configuration.item.identifier", null)
  );
  const query = new URLSearchParams(location.search);
  const adminmode = query.get("_adminmode");

  return (
    <BrowserRouter basename={basePath}>
      <ErrorBoundary>
        <WrapperFrame>
          <Switch>
            {!level_visibility && !adminmode && itemIdentifier &&(
              <Route
                path="/identifier::identifier"
                component={LevelSelectionComponent}
              />
            )}

            <Route
              path="/identifier::identifier"
              component={combinedScreens.Configurator}
            />
            <Route
              path="/code::code"
              component={combinedScreens.Configurator}
            />

            <Route
              path="/widget/identifier::identifier"
              component={combinedScreens.CalculationWidget}
            />
            <Route
              path="/widget/code::code"
              component={combinedScreens.CalculationWidget}
            />

            <Route
              path="/designer-preview-widget"
              component={combinedScreens.DesignerProductPreview}
            />

            <Redirect to="/identifier::identifier" />

            <Route component={NoMatch} />
          </Switch>
        </WrapperFrame>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routing;
